/*
 * Copyright (c) 2005-2024, Paycheck Planner
 * All rights reserved
 * 
 */

import React, { useEffect, useState } from "react";

import { Row, Col, Form, Button, Table, InputGroup } from "react-bootstrap";

import ProvinceControl from "../../components/molecules/ProvinceControl";
import FrequencyControl from "../../components/molecules/FrequencyControl";

import getPCPUrl from "../../components/pcpUrl";
import { useUnsecurePost } from "../../components/fetchHook";


const input_text_style = {
  textAlign: "right",
  boxSizing: "border-box",
  width: "100%"
}

const input_text2_style = {
  textAlign: "right",
}

const expense_labels = {
  textAlign: "right",

}

const list_style = {
  margin: "10px"
}

//-------------------------------------------------------------------------------------------------

function calcBudget(budget) {
  let total = 0;
  for (let i = 0; i < budget.length; i++) {
    let item = budget[i];

    let amt = item.amount.length > 0 ? parseFloat(item.amount) : 0;
    total += amt;
  }

  return total;
}

//-------------------------------------------------------------------------------------------------
//-------------------------------------------------------------------------------------------------

function CanadaPayRequired(props) {
  const { postData, response, isLoading, error } = useUnsecurePost();
  const [province, setProvince] = useState("NS");

  const [exp01, setExp01] = useState("0");
  const [exp02, setExp02] = useState("0");
  const [exp03, setExp03] = useState("0");
  const [exp04, setExp04] = useState("0");
  const [exp05, setExp05] = useState("0");
  const [exp06, setExp06] = useState("0");
  const [exp07, setExp07] = useState("0");
  const [exp08, setExp08] = useState("0");

  const [totalBudget, setTotalBudget] = useState("0");
  const [data, setData] = useState(null);


  useEffect(() => {
    updateTotalBudget();
  }, [exp01, exp02, exp03, exp04, exp05, exp06, exp07, exp08]);


  useEffect(() => {
    if (response === null) {
      return;
    }

    setData(response)
  }, [response]);



  function updateExpense(event) {
    event.preventDefault();

    let val = event.target.value;
    if (parseFloat(val) === NaN) {
      return;
    }

    switch (event.target.id) {
      case 'exp01':
        setExp01(val);
        break;
      case 'exp02':
        setExp02(val);
        break;
      case 'exp03':
        setExp03(val);
        break;
      case 'exp04':
        setExp04(val);
        break;
      case 'exp05':
        setExp05(val);
        break;
      case 'exp06':
        setExp06(val);
        break;
    }
  }


  function updateTotalBudget() {
    let e01 = parseFloat(exp01);
    let e02 = parseFloat(exp02);
    let e03 = parseFloat(exp03);
    let e04 = parseFloat(exp04);
    let e05 = parseFloat(exp05);
    let e06 = parseFloat(exp06);
    let e07 = parseFloat(exp07);
    let e08 = parseFloat(exp08);

    let total = e01+e02+e03+e04+e05+e06+e07+e08;

    setTotalBudget(total.toFixed(2));
  }


  const handleClick = async (event) => {
    event.preventDefault();
    event.stopPropagation();

    if (isLoading === true) {
      return;
    }

    let body = {
      "province": province,
      "expenses": parseFloat(totalBudget)
    };


    let url = getPCPUrl() + "calculators/canadapayrequired";
    await postData(url, JSON.stringify(body));
  }


  const div_style = {
    "fontSize": "0.8em"
  };


  return (
    <Row style={div_style}>

      <Col lg={{ span: 6, offset: 3 }}>
        <Form>
          <Row>
            <Col>
              <h6>How much do I need to earn to survive</h6>
              <p>Enter your estimated <u>Monthly Expenses</u> and assuming a 40 hour work week, find out the minimum <u>Hourly Rate</u> or <u>Salary</u>
                required to acheive an <u>Expense Ratio</u> of 70%, 80% and 90%. That will determine your <u>Spending Cash</u> for the month.</p>
            </Col>
          </Row>
          <Row>
            <ProvinceControl as={Col} label="Province" value={province} onChange={setProvince} />
          </Row>

          <Row>
            <Col xs={4} style={expense_labels}>Rent/Mortgage</Col>
            <Col xs={4}>
              <InputGroup size="sm">
                <InputGroup.Text>+</InputGroup.Text>
                <Form.Control type="text" id="exp01" size="sm" style={input_text2_style} value={exp01} onChange={updateExpense} />
              </InputGroup>
            </Col>

            <Col xs={4}>
              <span>Total 1234.56</span>
            </Col>
          </Row>

          <Row>
            <Col xs={4} style={expense_labels}>Groceries</Col>
            <Col xs={4}>
              <InputGroup size="sm">
                <InputGroup.Text>+</InputGroup.Text>
                <Form.Control type="text" id="exp02" size="sm" style={input_text2_style} value={exp02} onChange={updateExpense} />
              </InputGroup>
            </Col>
          </Row>

          <Row>
            <Col xs={4} style={expense_labels}>Utilities</Col>
            <Col xs={4}>
              <InputGroup size="sm">
                <InputGroup.Text>+</InputGroup.Text>
                <Form.Control type="text" id="exp03" size="sm" style={input_text2_style} value={exp03} onChange={updateExpense} />
              </InputGroup>
            </Col>
          </Row>

          <Row>
            <Col xs={4} style={expense_labels}>Transportation</Col>
            <Col xs={4}>
              <InputGroup size="sm">
                <InputGroup.Text>+</InputGroup.Text>
                <Form.Control type="text" id="exp04" size="sm" style={input_text2_style} value={exp04} onChange={updateExpense} />
              </InputGroup>
            </Col>
          </Row>

          <Row>
            <Col xs={4} style={expense_labels}>Child care</Col>
            <Col xs={4}>
              <InputGroup size="sm">
                <InputGroup.Text>+</InputGroup.Text>
                <Form.Control type="text" id="exp05" size="sm" style={input_text2_style} value={exp05} onChange={updateExpense} />
              </InputGroup>
            </Col>
          </Row>

          <Row>
            <Col xs={4} style={expense_labels}>Other</Col>
            <Col xs={4}>
              <InputGroup size="sm">
                <InputGroup.Text>+</InputGroup.Text>
                <Form.Control type="text" id="exp06" size="sm" style={input_text2_style} value={exp06} onChange={updateExpense} />
              </InputGroup>
            </Col>
          </Row>


          <Row>
            <Col xs={4} style={expense_labels}>Total</Col>
            <Col xs={4}>
              <InputGroup className="mb-3" size="sm">
                <InputGroup.Text>=</InputGroup.Text>
                <Form.Control type="text" size="sm" style={input_text2_style} value={totalBudget} readOnly />
              </InputGroup>
            </Col>
          </Row>


          <Button variant="primary" onClick={handleClick}>Submit</Button>
          {!isLoading ? null : <span>Loading</span>}
          <Button variant="secondary" onClick={props.onCancel}>Cancel</Button>

        </Form >







        <Row>
          <Col xs={8}>
          <Form>
          <Row>
            <ProvinceControl as={Col} label="Province" value={province} onChange={setProvince} />
          </Row>

          <Row>
            <Col xs={4} style={expense_labels}>Rent/Mortgage</Col>
            <Col xs={8}>
              <InputGroup size="sm">
                <InputGroup.Text>+</InputGroup.Text>
                <Form.Control type="text" id="exp01" size="sm" style={input_text2_style} value={exp01} onChange={updateExpense} />
              </InputGroup>
            </Col>
          </Row>

          <Row>
            <Col xs={4} style={expense_labels}>Groceries</Col>
            <Col xs={8}>
              <InputGroup size="sm">
                <InputGroup.Text>+</InputGroup.Text>
                <Form.Control type="text" id="exp02" size="sm" style={input_text2_style} value={exp02} onChange={updateExpense} />
              </InputGroup>
            </Col>
          </Row>

          <Row>
            <Col xs={4} style={expense_labels}>Utilities</Col>
            <Col xs={8}>
              <InputGroup size="sm">
                <InputGroup.Text>+</InputGroup.Text>
                <Form.Control type="text" id="exp03" size="sm" style={input_text2_style} value={exp03} onChange={updateExpense} />
              </InputGroup>
            </Col>
          </Row>

          <Row>
            <Col xs={4} style={expense_labels}>Transportation</Col>
            <Col xs={8}>
              <InputGroup size="sm">
                <InputGroup.Text>+</InputGroup.Text>
                <Form.Control type="text" id="exp04" size="sm" style={input_text2_style} value={exp04} onChange={updateExpense} />
              </InputGroup>
            </Col>
          </Row>

          <Row>
            <Col xs={4} style={expense_labels}>Child care</Col>
            <Col xs={8}>
              <InputGroup size="sm">
                <InputGroup.Text>+</InputGroup.Text>
                <Form.Control type="text" id="exp05" size="sm" style={input_text2_style} value={exp05} onChange={updateExpense} />
              </InputGroup>
            </Col>
          </Row>

          <Row>
            <Col xs={4} style={expense_labels}>Other</Col>
            <Col xs={8}>
              <InputGroup size="sm">
                <InputGroup.Text>+</InputGroup.Text>
                <Form.Control type="text" id="exp06" size="sm" style={input_text2_style} value={exp06} onChange={updateExpense} />
              </InputGroup>
            </Col>
          </Row>


          <Row>
            <Col xs={4} style={expense_labels}>Total</Col>
            <Col xs={8}>
              <InputGroup className="mb-3" size="sm">
                <InputGroup.Text>=</InputGroup.Text>
                <Form.Control type="text" size="sm" style={input_text2_style} value={totalBudget} readOnly />
              </InputGroup>
            </Col>
          </Row>


          <Button variant="primary" onClick={handleClick}>Submit</Button>
          {!isLoading ? null : <span>Loading</span>}
          <Button variant="secondary" onClick={props.onCancel}>Cancel</Button>

        </Form >
          </Col>

          <Col>
          </Col>
        </Row>

        <RequiredPay results={data} />

      </Col>

    </Row>
  );
}


function RequiredPay(props) {

  if (props.results === null) {
    return null;
  }

  let r = props.results;


  const pay_header_style = {
    textAlign: "center",
    padding: "2px"
  }


  return (
    <Table striped bordered hover>
      <thead>
        <tr>
          <th></th>
          <td style={{ background: "#90EE90" }}>70% = /88K</td>
          <td style={{ background: "#FED8B1" }}>80%</td>
          <td style={{ background: "#FFD6D7" }}>90%</td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Rate required</td>
          <td>{r.seventy.payRate.toFixed(2)}/88K</td>
          <td>{r.eighty.payRate.toFixed(2)}/88K</td>
          <td>{r.ninety.payRate.toFixed(2)}/88K</td>
        </tr>
        <tr>
          <td>Yearly</td>
          <td>{r.seventy.yearGross.toFixed(2)}</td>
          <td>{r.eighty.yearGross.toFixed(2)}</td>
          <td>{r.ninety.yearGross.toFixed(2)}</td>
        </tr>

        <tr>
          <td colSpan={4} style={pay_header_style}>Pay Period</td>
        </tr>

        <tr>
          <td>Gross</td>
          <td>{r.seventy.payGross.toFixed(2)}</td>
          <td>{r.eighty.payGross.toFixed(2)}</td>
          <td>{r.ninety.payGross.toFixed(2)}</td>
        </tr>
        <tr>
          <td>Net</td>
          <td>{r.seventy.payNet.toFixed(2)}</td>
          <td>{r.eighty.payNet.toFixed(2)}</td>
          <td>{r.ninety.payNet.toFixed(2)}</td>
        </tr>
        <tr>
          <td>Month Net</td>
          <td>{r.seventy.monthNet.toFixed(2)}</td>
          <td>{r.eighty.monthNet.toFixed(2)}</td>
          <td>{r.ninety.monthNet.toFixed(2)}</td>
        </tr>
        <tr>
          <td>Expenses</td>
          <td>{r.seventy.expenses.toFixed(2)}</td>
          <td>{r.eighty.expenses.toFixed(2)}</td>
          <td>{r.ninety.expenses.toFixed(2)}</td>
        </tr>
        <tr>
          <td>Available cash</td>
          <td>{r.seventy.monthDiff.toFixed(2)}</td>
          <td>{r.eighty.monthDiff.toFixed(2)}</td>
          <td>{r.ninety.monthDiff.toFixed(2)}</td>
        </tr>
      </tbody>
    </Table>
  );
}


export default CanadaPayRequired;

